import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WelcomeMessageFormComponent } from './welcome-message-form/welcome-message-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RenderersModule } from 'src/app/shared/renderers/renderers.module';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    WelcomeMessageFormComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RenderersModule,
    SharedModule,
  ]
})
export class WelcomeMessageModule { }
